import { buildFacetDesignOverrideLite, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import {
  FDBodyText, FDHeadlineText, FDSelectInput,
} from '@facet-wealth/design';
import { RadioGroupInput } from 'Packages/FacetDesign/Components/RadioGroupInput';
import { Disclosure } from 'Views/FreemiumEntry/HasRelationship/Content/Components/Disclosure';


export const fqResponseContactAndInfluencerInformationMetaOverrideSet = buildFacetDesignOverrideLite()
  .nameOverride('pageTitle', {
    _component: () => FDHeadlineText,
    _customProps: { size: 'lg', color: 'textSecondary' },
  }, overrideReadOnly)
  .nameOverride(['influencerDisclosure', 'influencerExpertTestimonialDisclosure'], {
    _component: () => Disclosure,
  }, overrideReadOnly)
  .nameOverride(['disclosure', 'generalDisclosure', 'formDisclosure'], {
    _component: () => Disclosure,
    _customProps: {
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride('influencerMemberTestimonialDisclosure', {
    _component: () => Disclosure,
    _customProps: {
      align: 'center',
      color: 'textPrimary',
    },
  }, overrideReadOnly)
  .nameOverride('contactInfoTitle', {
    _component: () => FDHeadlineText,
    _customProps: {
      align: 'center',
      size: 'sm',
    },
  }, overrideReadOnly)
  .nameOverride('contactFormDescription', {
    _component: () => FDBodyText,
    _customProps: {
      align: 'center',
      size: 'lg',
    },
  }, overrideReadOnly)
  .nameOverride(['age', 'householdIncome', 'estimatedSavings'], {
    _component: () => FDSelectInput,
    _customProps: { helperText: '', flex: 1 },
  }, overrideReadOnly)
  .nameOverride('residencyConfirmation', {
    _component: () => RadioGroupInput,
    _customProps: {
      direction: 'row',
    },
  }, overrideReadOnly)
  .nameOverride('influencerFeaturedInSectionTitle', {
    _component: () => FDHeadlineText,
    _customProps: {
      size: 'sm',
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride(['influencerUSATodayDescription', 'influencerFooterDisclosure'], {
    _component: () => Disclosure,
    _customProps: {
      align: 'start',
      color: 'textPrimary',
    },
  }, overrideReadOnly)
  .nameOverride(['influencerFooterGetStartedPhone', 'influencerFooterMemberQuestionsPhone', 'influencerFooterEmail', 'influencerFooterMediaInquiries', 'influencerFooterAddress', 'influencerFooterCopyright'], {
    _component: () => FDBodyText,

  }, overrideReadOnly);
